module.exports = __webpack_public_path__ + "static/img/dili.5108419e.png";